// extracted by mini-css-extract-plugin
module.exports = {"container":"list_container__hoU_D","stackHeader":"list_stackHeader__UUxUW"};